<dpac-modal title="Nuovo ente" size="custom" [canClose]="true" (closed)="dismiss()">
  <form modal-body [formGroup]="form" class="gap-4 grid grid-cols-1 md:grid-cols-2 w-full">

    <div class="relative">
      <dpac-select
        label="Tipologia"
        placeholder="Seleziona"
        formControlName="tipologia"
        [required]="true"
        [options]="tipologie()"
        [optionLabel]="'label'"
        [optionValue]="'value'" />
      @if (form.get('tipologia')?.invalid && form.get('tipologia')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Tipologia è obbligatoria</div>
      }
    </div>

    @if (form.get('tipologia')?.value === 'PR004') {
      <div class="relative">
        <dpac-input-field
          label="Cognome"
          placeholder="Cognome"
          formControlName="cognome"
          [required]="true" />
        @if (form.get('cognome')?.invalid && form.get('cognome')?.touched) {
          <div class="mt-1 text-red-500 text-xs">Cognome è obbligatorio</div>
        }
      </div>
    }

    <div class="relative">
      <dpac-input-field
        [label]="nomeLabel()"
        [placeholder]="nomeLabel()"
        formControlName="nome"
        [required]="true" />
      @if (form.get('nome')?.invalid && form.get('nome')?.touched) {
        <div class="mt-1 text-red-500 text-xs">{{ nomeLabel() }} è obbligatorio</div>
      }
    </div>

    <div class="relative">
      <dpac-select
        label="Categoria"
        placeholder="Seleziona"
        formControlName="categoria"
        [required]="true"
        [options]="categorie()"
        [optionLabel]="'label'"
        [optionValue]="'value'" />
      @if (form.get('categoria')?.invalid && form.get('categoria')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Categoria è obbligatoria</div>
      }
    </div>

    <div class="relative">
      <dpac-input-field
        label="Codice identificativo"
        placeholder="Codice identificativo"
        formControlName="codiceIdentificativo"
        labelTooltip="ISIL, ESC, Codice fiscale"
        [labelTooltipIcon]="{src: './assets/icons/Vector.svg'}" />
    </div>

    <div class="relative">
      <dpac-select
        label="Indirizzo (sede legale)"
        placeholder="Cerca indirizzo..."
        formControlName="indirizzo"
        [required]="true"
        [options]="addressSuggestions()"
        [lazy]="true"
        [search]="true"
        [optionLabel]="'indirizzoEsteso'"
        [optionValue]="'indirizzoEsteso'"
        (searchChange)="searchAddress($event)"
        (selectionChange)="onAddressSelect($event)" />
      @if (form.get('indirizzo')?.invalid && form.get('indirizzo')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Indirizzo è obbligatorio</div>
      }
    </div>

    <div class="relative">
      <dpac-input-field
        label="Civico"
        placeholder="Civico"
        formControlName="civico"
        [required]="true" />
      @if (form.get('civico')?.invalid && form.get('civico')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Civico è obbligatorio</div>
      }
    </div>

    <div class="relative">
      <dpac-input-field
        label="Cap"
        placeholder="Cap"
        formControlName="cap"
        [required]="true" />
      @if (form.get('cap')?.invalid && form.get('cap')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Cap non valido (5 cifre)</div>
      }
    </div>

    <div class="relative">
      <dpac-input-field
        label="Comune"
        placeholder="Comune"
        formControlName="comune"
        [required]="true" />
      @if (form.get('comune')?.invalid && form.get('comune')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Comune è obbligatorio</div>
      }
    </div>

    <div class="relative">
      <dpac-input-field
        label="Provincia"
        placeholder="Provincia"
        formControlName="provincia"
        [required]="true" />
      @if (form.get('provincia')?.invalid && form.get('provincia')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Provincia è obbligatoria</div>
      }
    </div>

    <div class="relative" [class.md:col-span-2]="lastFieldFullWidth()">
      <dpac-input-field
        label="Sito Web dell'ente"
        placeholder="https://..."
        formControlName="sitoWeb" />
      @if (form.get('sitoWeb')?.invalid && form.get('sitoWeb')?.touched) {
        <div class="mt-1 text-red-500 text-xs">Inserisci un URL valido (https://...)</div>
      }
    </div>

  </form>

  <div modal-buttons class="flex gap-4">
    <dpac-button
      classe="tertiary"
      label="Annulla"
      (onClick)="dismiss()" />
    <dpac-button
      classe="primary"
      label="Salva ente"
      [disabled]="form.invalid || submitting()"
      (onClick)="onSubmit()" />
  </div>
</dpac-modal>
